import fly from './flyio.js'
/* eslint-disable */
export function buriedPoint (type,studioCode) {
  fly.request({
	  method: 'get',
	  url: '/star/live/manage/star/data/live/buried/point',
	  params: {
	  	type: type,
	  	studioCode: studioCode
	  }
	})
	.then(res => {
	  if (res.success) {
	    
	  }
	})
	.catch(err => {
	  console.log(err)
	})
}
export default {
	buriedPoint: buriedPoint
}


// WEBPACK FOOTER //
// ./src/utils/utils.js